export default "__VITE_PUBLIC_ASSET__d8aa4279__"